module.exports = __webpack_public_path__ + "static/media/31.3f3a5741.jpg";